// ---------------------------------------------------
// ---------------------------------------------------
// set theme
(function(){
  // get/set theme early
  window.darkmode = window.localStorage.getItem('darkmode');
  if (darkmode === 'false') {
    document.documentElement.setAttribute('data-theme', 'light');
  } else {
    document.documentElement.setAttribute('data-theme', 'dark');
  }
  window.onload = function(){ 
    if (darkmode === 'true') {
      document.getElementById('darkmodeToggle').style = 'background: var(--mainColor); color: var(--button-text-active);';
    }
  };
}());